// extracted by mini-css-extract-plugin
module.exports = {"info":"_event__info__3uXOn","carousel":"_event__carousel__2T187","internalCarousel":"_event__internalCarousel___SS7S"};